import type { BackToSchool2026Phase2Variant } from '../constants/back-to-school-2026-phase-2-sale';

/**
 * CONENG-2622 Back to School 2026 **phase 2** maps to its own Sanity `promotionId` values so both
 * phases can sit in `PROMO_CAMPAIGNS` at once, each gated on its own IDs. `checkStartAndEndDateUTC`
 * in `src/pages/api/get-promotion.ts` performs the switchover at request time, so phase 1
 * (`bts50` / `bts10`) keeps winning until phase 2's start date passes.
 *
 * Gate on `promotionId` — never on `promoCode`. The coupons (`BTS50` / `BTS10`) are unchanged from
 * phase 1 and therefore cannot tell the two phases apart.
 *
 * G1 (`bts50-p2`) — full-price markets, 50% off. G2 (`bts10-p2`) — low-price markets, sitewide.
 */
export const BTS_2026_P2_G1_PROMOTION_ID = 'bts50-p2';
export const BTS_2026_P2_G2_PROMOTION_ID = 'bts10-p2';

export type Bts2026Phase2MarketTier = 'full' | 'low';

export function getBts2026Phase2MarketTier(variant: BackToSchool2026Phase2Variant): Bts2026Phase2MarketTier {
  return variant === 'g2' ? 'low' : 'full';
}

export function getBts2026Phase2Variant(promotionId: string | null | undefined): BackToSchool2026Phase2Variant | null {
  if (promotionId === BTS_2026_P2_G1_PROMOTION_ID) {
    return 'g1';
  }
  if (promotionId === BTS_2026_P2_G2_PROMOTION_ID) {
    return 'g2';
  }
  return null;
}

export function getBts2026Phase2SlideKey(variant: BackToSchool2026Phase2Variant): string {
  return `back-to-school-2026-phase-2-${variant}`;
}

/** `?force_promo=<promotionId>` wins over the live `usePromotion` response (preview QA only). */
export function resolveBts2026Phase2Variant(
  forcedPromotionId: string | null | undefined,
  promotionId: string | null | undefined
): BackToSchool2026Phase2Variant | null {
  return getBts2026Phase2Variant(forcedPromotionId) ?? getBts2026Phase2Variant(promotionId);
}
